export default __webpack_public_path__ + "static/media/480_store01-fr-web.0d1fcdc2.png";